import React from 'react'
import {
  get,
  Box,
  Table,
  useMediaSize,
  useTableDrawer,
} from '@ally/metronome-ui'
import styled from 'styled-components'
import { InvestAccount } from '@ally/data-types-accounts'
import { getColumns } from './TableColumnsDrawer'
import { WealthTableData } from './TableColumns'
import { useAccountTypes } from '../../AccountTypeContext'
import { useCustomizeDashboard } from '../../CustomizeDashboard/CustomizeDashboardContext/CustomizeDashboardContext'

const StyledBox = styled(Box)`
  /**
   * These styles create the effect that the drawer
   * extends the full width of the table, overriding
   * the default table row styles.
   **/

  position: relative;
  margin-left: -35px;
  margin-right: -35px;
  padding: ${get.space('sm')} 20px;
  background: #fff;
  border-left: 1px solid ${get.colors('gray-300')};
  border-right: 1px solid ${get.colors('gray-300')};
  border-bottom: 1px solid ${get.colors('gray-300')};
  box-shadow: 0 -4px 5px -2px rgba(0, 0, 0, 0.16);

  @media print {
    margin-left: -10px;
    margin-right: 0;
    display: block;
    overflow: visible;
  }
`
const StyledTableWrapper = styled.div`
  table {
    thead {
      tr {
        th {
          height: 1px;
        }
          div {
            height: 1px;
            width: 1px;
            position: absolute;
            overflow: hidden;
            top: -10px;
          }
        }
      }
    }
  }
`

interface DrawerProps {
  sortedInvwAccounts: InvestAccount[]
  hasStaleData: boolean
}

const WealthManagementDrawer: React.FC<DrawerProps> = ({
  sortedInvwAccounts,
  hasStaleData,
}) => {
  const { isWealthPartialOutage } = useAccountTypes()
  const [{ dashboardView }] = useCustomizeDashboard()
  const { targetRef } = useTableDrawer<WealthTableData>()
  const isLgDown = useMediaSize('LgDown')

  return (
    <StyledBox data-testid="wealth-drawer">
      <StyledTableWrapper>
        <Table
          ref={targetRef}
          data={sortedInvwAccounts}
          columns={getColumns({
            isLgDown,
            isWealthPartialOutage,
            view: dashboardView,
            hasStaleData,
          })}
          captionText="Information about your Ally Wealth Management accounts"
          fullWidth
          suppressMdDownLayout
        />
      </StyledTableWrapper>
    </StyledBox>
  )
}

export default WealthManagementDrawer
